import type { Building } from "@senciamatch/shared/models/building";
import type { Staff } from "@senciamatch/shared/models/staff";
import type { StaffShift } from "@senciamatch/shared/models/staffShift";
import * as XLSX from "xlsx";
import { buildShiftBatchData } from "./parsers";
import type { CellData } from "./types";

/**
 * ExcelファイルからCellDataを抽出
 */
const extractCellData = (input: Uint8Array): CellData => {
  // InputからExcelデータを読み込む
  const workbook = XLSX.read(input, { type: "buffer", cellStyles: true });

  // 最初のシートを取得
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  // セルの値とコメントを格納するオブジェクト
  const cellData: CellData = {};

  // 各セルをループ
  for (const cellAddress in worksheet) {
    if (cellAddress[0] === "!") continue; // メタデータをスキップ

    const cell = worksheet[cellAddress];

    cellData[cellAddress] = {
      value: cell.v, // セルの値
      comment: cell.c ? cell.c[0].t : undefined, // コメントがあれば取得
    };
  }

  return cellData;
};

/**
 * ExcelファイルからShiftBatchInputを作成
 */
const parse = (input: Uint8Array, buildings: Building[], staffs: Staff[], staffShifts: StaffShift[]) => {
  const cellData = extractCellData(input);
  return buildShiftBatchData(cellData, buildings, staffs, staffShifts);
};

export const excelParserBuildingShiftTable = {
  parse,
};
